import { createFileRoute } from '@tanstack/react-router'
import MarketingAutomacoesNovaPage from '@/pages/dashboard/marketing-automacoes-nova-page'
import { RequireModule } from '@/components/auth'
import { MODULES } from '@/constants/modules'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/automacoes/nova/',
)({
  component: function MarketingAutomacoesNovaRoute() {
    const { dashboardId } = Route.useParams()

    return (
      <RequireModule module={MODULES.AUTOMACOES} dashboardId={dashboardId}>
        <MarketingAutomacoesNovaPage dashboardId={dashboardId} />
      </RequireModule>
    )
  },
})
